import React, { Fragment, useState, useEffect } from "react";
import { BiPhoneCall } from "react-icons/bi";
import { Link, useLocation } from "react-router-dom";

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "About", path: "/aboutus" },
    { name: "Gallery", path: "/gallery" },
    { name: "New Arrival", path: "/newarrival" },
    { name: "Sculpture", path: "/sculpture" },
    { name: "Contact", path: "/contact" }
  ];

  return (
    <Fragment>
      <nav 
        className={`px-4 fixed top-0 w-full z-50 transition-all duration-500 border-b ${
          scrolled 
            ? "bg-black/95 backdrop-blur-md border-zinc-900/80 shadow-2xl py-3 md:py-4" 
            : "bg-black/40 backdrop-blur-sm border-transparent py-4 md:py-5"
        }`}
      >
        <div className="container md:px-28 flex flex-wrap justify-between items-center mx-auto">
          
          <div className="flex justify-between flex-wrap w-full md:w-auto items-center">
            <Link to="/" className="flex items-center group">
              <span className="text-white font-light tracking-[0.25em] group-hover:text-accent transition-colors duration-500 text-sm md:text-base uppercase">
                Suresh Gosavi
              </span>
            </Link>
            <div className="md:hidden flex items-center">
              <a 
                href="tel:+919096615282" 
                className="text-gray-300 hover:text-accent transition-colors duration-300 text-xl"
              >
                <BiPhoneCall />
              </a>
            </div>
          </div>
         
          <div className="w-full block md:w-auto">
            <ul className="flex mt-4 overflow-x-auto whitespace-nowrap scroll-hidden md:flex-row md:space-x-8 md:mt-0 md:text-sm text-xs font-light tracking-wide uppercase text-gray-400">
              {navLinks.map((link) => {
                const isActive = location.pathname.toLowerCase() === link.path.toLowerCase();
                return (
                  <li key={link.path} className="group relative py-2 md:py-0">
                    <Link 
                      to={link.path} 
                      className={`block text-center pr-4 pl-3 rounded md:bg-transparent md:p-0 transition-colors duration-300 ${
                        isActive ? "text-accent" : "text-gray-400 hover:text-white"
                      }`}
                    >
                      {link.name}
                    </Link>
                    <span 
                      className={`absolute bottom-0 left-3 right-4 h-[1px] bg-accent transition-all duration-300 ${
                        isActive ? "w-[calc(100%-28px)]" : "w-0 group-hover:w-[calc(100%-28px)]"
                      } md:left-0 md:right-0 md:bottom-[-4px] ${
                        isActive ? "md:w-full" : "md:w-0 md:group-hover:w-full"
                      }`}
                    />
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </nav>
    </Fragment>
  );
}

export default Navbar;
